module.exports = __webpack_public_path__ + "img/bfgoodrich-logo.19b6767e.jpg";